import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container, Modal } from 'react-bootstrap';
import './Home.css';
import lionsImage from './assets/Logo-myn.png';

function CancelReservation() {
  const [formData, setFormData] = useState({    
    email: '',
    reservationid: ''
  });

  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false); // show/hide modal
  const [status, setStatus] = useState(null); // loading | success | error

  const handleClosePopup = () => {
    setShowPopup(false);
    if (status === 'success') navigate('/'); // optional redirect after success
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    try {
      const response = await fetch('https://joulukonsertti.lcmynamaki.fi/poistavaraus', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.status) {
          setStatus('success');
          setFormData({ reservationid: '', email: ''});
          setShowPopup(true);
        } else {
          throw new Error(data.message  || null); 
        }
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Error sending reservation:', error);
      setStatus('error');
      setErrorMessage(error.message || 'Varauksen peruutus epäonnistui. Yritä uudelleen.\n\nOta tarvittaessa yhteyttä info@lcmynamaki.fi');
      setShowPopup(true);
    }
  };

  return (
    <div className="home-container">   
    <button className="takaisin text-red-500 btn btn-dark" onClick={() => navigate('/')}>X</button>   
    <div className="text-container">
        <p className="title1st-text">Mynämäen joulukonsertti</p>
      <p className="artist">Anne Mattilan joulu</p>
     </div>
    <Container className="mt-5" style={{ maxWidth: '500px' }}>
      <h3 className="text mb-4 ">Haluatko perua jo varaamasi liput?</h3>
      
      <p className="text mb-4">Anna sähköpostilla saamasi varausnumero ja sähköpostiosoitteesi ja peru varaus.</p>
      <Form onSubmit={handleSubmit}>

        <Form.Group className="mb-3" controlId="formEmail">
          <Form.Label>Sähköposti</Form.Label>
          <Form.Control
            type="email"
            //placeholder="Syötä sähköpostiosoitteesi"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formName">
          <Form.Label>Varausnumero</Form.Label>
          <Form.Control
            type="text"
            //placeholder="Syötä nimesi"
            name="reservationid"
            value={formData.reservationid}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Button            
          variant="outline-dark"
          type="submit"
          className="cancellation-button w-100 text-white"
          disabled={status === 'loading'}
        >
          {status === 'loading' ? 'Perutaan...' : 'Peruuta varaus'}
        </Button>
      </Form>

            {/* 🪟 Popup Modal for messages */}
      <Modal show={showPopup} onHide={handleClosePopup} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {status === 'success' ? 'Varaus peruttu!' : 'Jotain meni pieleen'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ whiteSpace: 'pre-line' }}>
          {status === 'success'
            ? ''
            : errorMessage + "\n\nOta tarvittaessa yhteyttä info@lcmynamaki.fi"}
        </Modal.Body>
        <Modal.Footer>
          <Button variant={status === 'success' ? 'success' : 'danger'} onClick={handleClosePopup}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>

       <div className="logot-bck">
        
      </div>
      <img className="logot" src={lionsImage} alt="A picture of a lion"></img>
    </div>
  );
}

export default CancelReservation;